import { render, staticRenderFns } from "./CardVazio.vue?vue&type=template&id=0a1f9716"
import script from "./CardVazio.vue?vue&type=script&lang=js"
export * from "./CardVazio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports